import {useLocation, useNavigate} from "react-router";
import {useEffect, useMemo, useRef, useState} from "react";
import {getI18n, useTranslation} from "react-i18next";
import cookies from "../../../utils/cookies";
import {useSelector} from "react-redux";
import {useNavigateTo} from "../../../hooks/useNavigateTo";
import {useLogout} from "../../../api/login";
import Drawer from "../../Drawer";

const navs = [
  {
    name: '首页',
    path: '/'
  },
  {
    name: '预约服务',
    path: '/bookingList'
  },
  {
    name: '资讯分享',
    path: '/news'
  },
  {
    name: '产品分类',
    path: '/goodsList'
  },
  {
    name: '购物车',
    path: '/cart'
  },
  {
    name: '我的',
    path: '/my'
  },
  {
    name: '联系我们',
    path: '/callus'
  },
];

function Navigator({ title, goback, gobackHandle, right, backgroundColor, noBorder }) {
  const navigate = useNavigate();
  const navigateTo = useNavigateTo();
  const [opacity, setOpacity] = useState(0);
  const [drawerNavVisible, setDrawerMyVisible] = useState(false);
  const { logout } = useLogout();
  const { t } = useTranslation();
  const agentInfo = cookies.getAgentInfo();
  const ref = useRef(null);
  let scrollEvent = null;
  const location = useLocation();
  const state = useSelector(state => state);
  const menus = state.myMenus;
  const lang = getI18n().language
  
  const setDrawerNavVisible = (state) => {
    if (!cookies.getToken()) {
      return navigateTo('/login');
    } else {
      setDrawerMyVisible(state);
    }
  };
  
  const leftHandle = () => {
    if (gobackHandle) {
      gobackHandle();
      return;
    }
    if (goback) {
      navigate(-1);
    }
  };
  
  const navBar = useMemo(() => {
    if (agentInfo.navBar) {
      let res = JSON.parse(agentInfo.navBar);
      res = res.filter(item => item.state);
      
      let hasProduct = res.find(item => item.path === '/goodsList');
      
      if (!hasProduct) {
        res = res.filter(item => item.path !== '/');
      }
      
      return res.sort((a, b) => a.sort - b.sort);
    }
    return navs;
  }, [agentInfo]);
  
  useEffect(() => {
    let scrollTop = document.documentElement.scrollTop;
    
    if (backgroundColor === 'transparent' && ref.current) {
      if (scrollTop > ref.current.offsetHeight) setOpacity(1);
      
      scrollEvent = document.addEventListener('scroll', (e) => {
        scrollTop = document.documentElement.scrollTop;
        if (scrollTop > -1 && scrollTop < (ref.current?.offsetHeight * 2)) {
          let res = Math.round((scrollTop / ref.current.offsetHeight) * 100) / 100;
          setOpacity(res > 1 ? 1 : res);
        }
      });
    }
    return () => {
      if (scrollEvent) {
        document.removeEventListener('scroll');
        scrollEvent = null;
      }
    };
  }, []);
  
  const _noBorder = noBorder ? { border: 'none' } : {};
  return (
    <>
      <div ref={ref}
           className={`hidden flex-row items-center z-[99] bg-white
                    mdmax:flex w-[100%] mdmax:fixed border-[#eee] ${backgroundColor !== 'transparent' ? 'border-bottom-1px' : ''}`}
           style={{
             ..._noBorder,
             backgroundColor:
               backgroundColor === 'transparent'
                 ? `rgba(255,255,255,${opacity})`
                 : backgroundColor
           }}>
        <a className={'w-[52px] py-[12px] px-[18px]'} onClick={leftHandle}>
          {
            goback && <i className={'iconfont icon-back text-[16px]'}></i>
          }
        </a>
        <h6 className={'text-[17px] py-[12px] font-bold text-center flex-1'}>
          {title ? t(title) : agentInfo.agentName}
        </h6>
        <a className={'min-w-[52px] py-[12px] px-[18px] link'}>
          {right}
          {/*语言*/}
        </a>
        {
          !['/login', '/forgetPwd','/register'].includes(location.pathname) ? <i
            onClick={() => setDrawerNavVisible(!drawerNavVisible)}
            className={'absolute top-[8px] right-[10px] iconfont icon-more text-[24px] hidden mds:inline-block'}></i> : null
        }
      </div>
      <Drawer visible={drawerNavVisible}
              width={'65%'}
              offsetTop={50}
              onToggle={setDrawerNavVisible}
              className={'md:hidden'}
              wrapClassName={'pr-0'}
      >
        <div className={''}>
          <div className="text-right pr-[24px]">
            <i onClick={() => setDrawerNavVisible(false)}
               className="iconfont icon-delete text-[18px]"></i>
          </div>
          {
            navBar.map((nav, i) => (
              <a className="w-[100%] block py-[15px] text-[17px] mdmax:text-[14px] border-b-[1px]"
                 onClick={() => {
                   setDrawerMyVisible(false)
                   navigateTo(nav.path)}
                 }
                 key={i}>
                {lang === 'en' ? nav.nameEN : nav.name}
              </a>
            ))
          }
          <a onClick={logout}
             className="w-[100%] block py-[20px] text-[17px] mdmax:text-[14px] border-b-[1px]">
            {t('退出')}
          </a>
        </div>
      </Drawer>
    </>
  );
}

Navigator.container = ({ children, className = '', style }) => {
  return <div className={`container-center mdmax:pt-[50px] ${className}`} style={style}>{children}</div>;
};

export default Navigator;
